import { useState } from 'react'
import { patchSetting } from 'src/hooks/useCardSettings'
import { useDispatch, useSelector } from 'react-redux'
import { settingsDrawerOpenSuccess } from 'src/reducers/course/action'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'
import ContainerMediaGalery from 'src/container/image-gallery'
import React from 'react'
import { track } from '@amplitude/analytics-browser'
import {
  createCustomBadgeAction,
  deleteCustomBadgeAction,
} from 'src/reducers/card/action'

export const useBadgeSettings = (badgeSettings, settings) => {
  const dispatch = useDispatch()
  const courseIdFromState = useSelector(state => state.course.course?.id)
  const [ribbonText, setRibbonText] = useState(badgeSettings.badgeRibbonText || '')
  const [content, setContent] = useState(badgeSettings.badgeTitle || '')
  const [selectedBadge, setSelectedBadge] = useState(badgeSettings.badgeId)
  const [modalOpen, setModalOpen] = useState(false)
  const [activeTab, setActiveTab] = useState(
    badgeSettings.userSelectedTemplate === false ? 0 : badgeSettings.badgeType === 'custom' ? 0 : 1,
  )
  const [customBadgeImage, setCustomBadgeImage] = useState(
    badgeSettings.customBadgeImage || '',
  )
  const [customBadgeId, setCustomBadgeId] = useState(
    badgeSettings.customBadgeId || null,
  )
  const [customBadges, setCustomBadges] = useState([])

  const handleSelectedBadge = e => {
    setSelectedBadge(e)
    patchSetting(
      dispatch,
      settings.cardId,
      settings.id,
      'badge',
      JSON.stringify({
        ...badgeSettings,
        badgeId: e,
        badgeType: 'default',
        userSelectedTemplate: true,
        customBadgeId: null,
        customBadgeImage: '',
      }),
    )
    setCustomBadgeImage('')
  }

  const handleRibbonText = e => {
    patchSetting(
      dispatch,
      settings.cardId,
      settings.id,
      'badge',
      JSON.stringify({ ...badgeSettings, badgeRibbonText: e }),
    )
  }

  const handleContent = e => {
    patchSetting(
      dispatch,
      settings.cardId,
      settings.id,
      'badge',
      JSON.stringify({ ...badgeSettings, badgeTitle: e }),
    )
  }

  const handlePopupOpen = () => {
    setModalOpen(modalOpen => !modalOpen)
  }

  const handleContentText = e => {
    if (e.length <= 32) setContent(e)
  }

  const handleRibbon = e => {
    if (e.length <= 12) setRibbonText(e)
  }

  const handleDrawerClose = () => {
    dispatch(settingsDrawerOpenSuccess())
  }

  const handleTabChange = tabIndex => {
    setActiveTab(tabIndex)
  }

  const handleOpenGallery = () => {
    const onOk = items => {
      const imageUrl = items[0].url
      setCustomBadgeImage(imageUrl)

      dispatch(
        createCustomBadgeAction(
          {
            name: content || 'Custom Badge',
            imageUrl: imageUrl,
            cardSettingId: settings.id,
          },
          createResponse => {
            if (createResponse?.data) {
              const newBadge = createResponse.data
              setCustomBadgeId(newBadge.id)
              setCustomBadges(prev => [...prev, newBadge])
              const courseIdFromPath =
                window.location.pathname.match(/\/mini-course\/([^/]+)/)?.[1] ||
                null
              const courseId = courseIdFromState || courseIdFromPath
              track('custom_badge_uploaded', {
                course_id: courseId,
                badge_image_url: imageUrl,
              })

              patchSetting(
                dispatch,
                settings.cardId,
                settings.id,
                'badge',
                JSON.stringify({
                  ...badgeSettings,
                  badgeType: 'custom',
                  userSelectedTemplate: false,
                  customBadgeId: newBadge.id,
                  customBadgeImage: imageUrl,
                  badgeTitle: content || 'Custom Badge',
                }),
              )
            }
          },
        ),
      )

      dispatch(messageBoxHideAction())
    }

    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: 'Media Gallery',
          component: (
            <ContainerMediaGalery onOk={onOk} setImageURL={() => {}} />
          ),
          variant: MessageBoxVariant.DRAGGABLE,
          maxHeight: '640px',
        }),
      ),
    )
  }

  const handleSelectCustomBadge = badge => {
    setCustomBadgeImage(badge.imageUrl)
    setCustomBadgeId(badge.id)
    patchSetting(
      dispatch,
      settings.cardId,
      settings.id,
      'badge',
      JSON.stringify({
        ...badgeSettings,
        badgeType: 'custom',
        customBadgeId: badge.id,
        customBadgeImage: badge.imageUrl,
        badgeTitle: badge.name || content,
      }),
    )
  }

  const handleDeleteCustomBadge = badgeId => {
    dispatch(
      deleteCustomBadgeAction(badgeId, () => {
        setCustomBadges(prev => prev.filter(b => b.id !== badgeId))
        if (customBadgeId === badgeId) {
          setCustomBadgeImage('')
          setCustomBadgeId(null)
          patchSetting(
            dispatch,
            settings.cardId,
            settings.id,
            'badge',
            JSON.stringify({
              ...badgeSettings,
              badgeType: 'default',
              customBadgeId: null,
              customBadgeImage: '',
            }),
          )
        }
      }),
    )
  }

  return {
    ribbonText,
    setRibbonText,
    content,
    setContent,
    selectedBadge,
    setSelectedBadge,
    modalOpen,
    setModalOpen,
    handleSelectedBadge,
    handleRibbonText,
    handleContent,
    handlePopupOpen,
    handleContentText,
    handleRibbon,
    handleDrawerClose,
    activeTab,
    handleTabChange,
    customBadgeImage,
    customBadgeId,
    customBadges,
    handleOpenGallery,
    handleSelectCustomBadge,
    handleDeleteCustomBadge,
  }
}
